import * as React from "react";
import { useSelector } from "react-redux";

import { Alert } from "@livechat/design-system-react-components";

import { IDeviceListItem } from "interfaces/entities/devices";
import { selectMaxWebpushSubscriptionsPerAgent } from "store/entities/license";
import { getCurrentAgentId } from "store/features/session";

import { isPushNotificationSupported } from "./utils";

interface IProps {
  webpushSubscription: IDeviceListItem[];
  agentId: string;
}

const BrowserNotificationsAlert: React.FC<IProps> = ({ webpushSubscription, agentId }) => {
  const loggedInAgentId = useSelector(getCurrentAgentId);
  const maxWebpushSubs = useSelector(selectMaxWebpushSubscriptionsPerAgent);

  const isWebpushSupported = isPushNotificationSupported();
  const isYourAcc = agentId === loggedInAgentId;
  const reachedTheLimit = maxWebpushSubs === webpushSubscription?.length;

  if (!isYourAcc) {
    return <Alert>You can set browser notifications for your account only.</Alert>;
  }

  if (!isWebpushSupported) {
    return <Alert>The browser you&apos;re currently using doesn&apos;t support notifications.</Alert>;
  }

  if (reachedTheLimit) {
    return (
      <Alert>
        You&apos;ve reached the limit of {maxWebpushSubs} browsers with notifications enabled. Disable notifications for
        any of the browsers in the list below to enable a new one.
      </Alert>
    );
  }

  return null;
};

export default BrowserNotificationsAlert;
